import { Result, Button } from 'antd';
import fun from './../../common/common_fun'

// eslint-disable-next-line import/no-anonymous-default-export
export default () => (
    <Result
        status="404"
        title=""
        subTitle=""
        extra={<Button onClick={() => window.location.href = "/#/index"} type="primary">回到首页新</Button>}
    />
);